import * as React from 'react';
import { useEffect, useState } from 'react';
import { History } from 'history';

interface QueryParams {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_id?: string;
    utm_term?: string;
    referral?: string;
}

export const QueryParamsContext = React.createContext<null | QueryParams>(null);

export const QueryParamsProvider: React.FC<{ history: History }> = (props) => {
    const getQueryParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        // @ts-expect-error TS config expects es5 but we are using es6 features
        return Object.fromEntries(urlParams.entries()) as QueryParams;
    };
    const [queryParams, setQueryParams] = useState<QueryParams>(getQueryParams);
    useEffect(() => {
        props.history.listen(() => {
            setQueryParams(getQueryParams);
        }
        ); }, []);

    return (
        <QueryParamsContext.Provider value={queryParams}>
        {props.children}
        </QueryParamsContext.Provider>
    );
};



// WEBPACK FOOTER //
// ./src/webportal/components/contextProviders/QueryParamsProvider.tsx